import { Card as BlockheadCard } from '@sparemin/blockhead';
import DialogBox from 'components/DialogBox';
import styled from 'styled-components';

export const Dialog = styled(DialogBox)`
  .MuiDialogContent-root {
    padding: 0;
    overflow: hidden;
    width: 500px;
  }
`;

export const Card = styled(BlockheadCard)`
  border-radius: 8px;
`;

export const CardHeader = styled(BlockheadCard.Header)`
  padding: 40px 40px 0;
`;

export const CardContents = styled(BlockheadCard.Contents)`
  padding: 30px 40px 0;
`;

export const CardFooter = styled(BlockheadCard.Footer)`
  padding: 0 0 40px 0;
`;
